import { LoadingState, UnauthenticatedState } from "../types";
import { UnauthenticatedScreen } from "./UnauthenticatedScreen";

export function FallbackScreen(
  authState: JSX.IntrinsicAttributes & (UnauthenticatedState | LoadingState)
) {
  return <UnauthenticatedScreen {...authState} />;
}
